import SidePanelInfo from "../components/SidePanelInfo"
import ActionBar from "../actions/ActionBar";
import EditAction from "../actions/EditAction";
import BlockUserAction from "../actions/BlockUserAction";
import SidePanelUserAccess from "../components/SidePanelUserAccess"
import SidePanelOperatorAccess from "../components/SidePanelOperatorAccess";
import { EntityNames } from "../../../../../enums/EntityNames";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext";
import { hasAccountBasedPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { useParams } from "react-router";

export default function SidePanelUsers({ data, onViewPage }: any) {
    const { permissions, cellTrakOperatorClaim } = usePermissions();
    const { entityId } = useParams();

    const canManageUser = 
        hasAccountBasedPermission(entityId, permissions!, PermissionTypes.write, PermissionConcerns.Customer_Account_Users, cellTrakOperatorClaim) ||
        hasAccountBasedPermission(entityId, permissions!, PermissionTypes.write, PermissionConcerns.Manage_CellTrak_Operator, cellTrakOperatorClaim) ||
        hasAccountBasedPermission(entityId, permissions!, PermissionTypes.write, PermissionConcerns.Add_Account, cellTrakOperatorClaim);

    return (<>
        {data &&
            <>
                <div className="display--flex gap--s">
                    <h2>{data.name}</h2>
                </div>
                <ActionBar>
                    {canManageUser && data.canEdit && <EditAction id={data.id} entityName={data.entityName} />}
                    {canManageUser && data.canEdit && <BlockUserAction data={data} />}
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Email", value: data.email },
                        { label: "Telephone number", value: data.phoneNumber }
                    ]}
                />

                {data.entityName === EntityNames.users &&
                    <SidePanelUserAccess
                        targetUserId={data.id}
                    />
                }

                {data.entityName === EntityNames.operators &&
                    <SidePanelOperatorAccess
                        targetUserId={data.id}
                    />
                }
            </>
        }
    </>)
}
